import { render, staticRenderFns } from "./formBtn.vue?vue&type=template&id=673adcf4&"
import script from "./formBtn.vue?vue&type=script&lang=js&"
export * from "./formBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports